import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://gattogianluca.com';

const SEOHead = ({
  title = "3D Environment & Prop Models — Gianluca Gatto",
  description = "Photorealistic 3D environments and game-ready props — shopfronts, vending machines, signage and street furniture, modelled in Blender. On TurboSquid and CGTrader.",
  keywords = "3D environment models, game ready props, photorealistic 3D models, PBR props, environment art, Blender 3D models",
  image = "/og-image.jpg",
  imageAlt,
  url,
  type = "website",
  noindex = false
}) => {
  const location = useLocation();
  // Only append brand if title is short enough to fit under 60 chars
  const SUFFIX = ' | Gianluca Gatto';
  const fullTitle = title.includes('Gianluca Gatto')
    ? title
    : (title.length + SUFFIX.length <= 60 ? `${title}${SUFFIX}` : title);
  const pathname = location.pathname.endsWith('/') ? location.pathname : `${location.pathname}/`;
  const canonicalUrl = url || `${SITE_URL}${pathname}`;
  // Contentful asset URLs are protocol-relative (//images.ctfassets.net/…)
  const normalizedImage = image.startsWith('//') ? `https:${image}` : image;
  const absoluteImage = normalizedImage.startsWith('http') ? normalizedImage : `${SITE_URL}${normalizedImage}`;
  const altText = imageAlt || (image === '/og-image.jpg'
    ? 'Akihabara street 3D environment by Gianluca Gatto'
    : fullTitle);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Gianluca Gatto" />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={absoluteImage} />
      {image === "/og-image.jpg" && <meta property="og:image:width" content="1200" />}
      {image === "/og-image.jpg" && <meta property="og:image:height" content="630" />}
      <meta property="og:image:alt" content={altText} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Gianluca Gatto" />
      <meta property="og:locale" content="en_US" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={absoluteImage} />
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default SEOHead;
